.image {
  flex-shrink: 0;
}
